import React, { useEffect, useState } from 'react'
import "./ViewSuiviTransmission.css"
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { getInstitutionsCategoriesCreated, getAgent, getRoles, getAgents, updateAgent, addAgent, getInstitutionsOfCategory, getLastTransmissionDate, getInstitutionsProducts, addTaux, viewTauxProducts, getSuiviTransmissionDetails } from '../../services/http';
import { useNavigate, useParams } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection, reload } from '../../utils/utils';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Navbar from '../../appShell/Navbar/Navbar';
import Select, { StylesConfig } from 'react-select';
import { FaArrowAltCircleLeft } from "react-icons/fa";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';


const ViewSuiviTransmission = (props) => {

    const { operationType } = props;
    const navigate = useNavigate();
    const id_suivi_transmission = useParams()
    registerLocale('fr', fr)
    const [transmissionDate, setTransmissionDate] = useState(new Date());
    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);


    const [products, setProducts] = useState();

    // const [displayLoader, setDisplayLoader] = useState(operationType == "new" ? false : true);



    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        let type;
        if (operationType == "new") { type = "Ajout" } else { type = "Visualisation" }
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Suivi", firstLevelLink: "/suivi-transmission", secondLevelText: "Transmission", secondLevelLink: "/suivi-transmission", thirdLevelText: "Visualisation", thirdLevelLink: "suivi-transmission/:id_suivi_transmission"
            }
        });
        handleMenuSelection("monitoring", dispatch, states);
        handleSubMenuSelection("suivi-transmission", dispatch)
    }, [])

    useEffect(async() => {
        const response = await getSuiviTransmissionDetails(states.userToken.access_token, id_suivi_transmission)
        if (response.response && response.response.status !== 200) {
            console.log("Suivi of transmission error ", response.response)
        } else {
            console.log("Suivi of transmission data ", response.data)
            const moisReformat = parseInt(response.data.transmission.mois);
            setTransmissionDate(new Date(`${moisReformat}/15/${response.data.transmission.annee}`))
            setProducts(response.data.taux)
            var newData = response.data.taux.map(value => ({
                product_id: value.product.id,
                libelle: value.product.libelle,
                taux: value.taux,
            }))
            console.log("New Data ", newData)
            dispatch({
                type: "SET",
                key: "suiviTransmissionProduits",
                payload: newData,
            });
        }
    }, [])
    
    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing">

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        <div className="row pl-3 mt-2">
                            <button className="btn btn-rounded mb-2 mr-2" onClick={() => { navigate("/suivi-transmission") }}><FaArrowAltCircleLeft className="mr-1" /> Retour</button>
                        </div>
                        <div className="widget widget-content widget-content-area mt-3" id="add-edit-transmission">
                            <div className="w-90 mx-auto">
                                <h5 className="modal-title py-3 mb-3 text-left " id="exampleModalLabel">{operationType == "new" ? "Nouvelle Transmission" : "Voir Transmission"}</h5>
                                <p className="d-flex flex-nowrap text-center my-3">Transmission de : <div className="ml-2">
                                    <DatePicker
                                        disabled={true}
                                        selected={transmissionDate}
                                        onChange={(date) => setTransmissionDate(date)}
                                        dateFormat="MM/yyyy"
                                        locale="fr"
                                        placeholderText="Cliquez"
                                        showMonthYearPicker
                                        showFullMonthYearPicker
                                    />
                                </div> </p>
                            </div>

                            {states.suiviTransmissionProduits ? states.suiviTransmissionProduits.map((product) =>
                                <div key={product.product_id} class="input-group mb-0 row col-xs-12 col-sm-9  mx-auto d-flex flex-nowrap">
                                    <div class="input-group-prepend" style={{width: "80%", borderRadius: "5px 0 0 5px"}}>
                                        <span class="input-group-text w-100" id="basic-addon7">{product.libelle} </span>
                                    </div>
                                    <input style={{borderRadius: "0", fontWeight: "600"}} disabled={true} type="number" value={product.taux}  min={0} class="form-control product-input text-dark" id="basic-url" aria-describedby="basic-addon3" placeholder="" />
                                    <div class="input-group-prepend border-left-none" style={{width: "8%"}}>
                                        <span style={{borderRadius: "0 5px 5px 0"}} class="input-group-text w-100 border-left-none" id="basic-addon7">%</span>
                                    </div>
                                </div>
                            ) : <h2>Aucun Produit</h2>
                            }
                            <div className="text-center py-3">
                                
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>



    )
}

export default ViewSuiviTransmission